import { render, staticRenderFns } from "./CountryDetailsTable.vue?vue&type=template&id=3b0f3b8c&scoped=true&"
import script from "./CountryDetailsTable.vue?vue&type=script&lang=js&"
export * from "./CountryDetailsTable.vue?vue&type=script&lang=js&"
import style0 from "./CountryDetailsTable.vue?vue&type=style&index=0&id=3b0f3b8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0f3b8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
